import Vue from 'vue'
import { URL_MANAGEMENT } from '@/constants/urls.js'
import { STATISTICS, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [STATISTICS.STATE.IDENTITY_STATISTICS]: {},
  [STATISTICS.STATE.BUSINESS_STATISTICS]: {}
}

const actions = {
  async [STATISTICS.ACTIONS.GET_IDENTITY_STATISTICS] ({ commit, dispatch }) {
    const model = {
      url: `${Vue.getIdentityHost()}${URL_MANAGEMENT}/statistics?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATISTICS.MUTATIONS.GET_IDENTITY_STATISTICS, resp.data)
  },
  async [STATISTICS.ACTIONS.CLEAR_IDENTITY_STATISTICS] ({ commit }) {
    commit(STATISTICS.MUTATIONS.CLEAR_IDENTITY_STATISTICS)
  },
  async [STATISTICS.ACTIONS.GET_BUSINESS_STATISTICS] ({ commit, dispatch }) {
    const model = {
      url: `${Vue.getBusinessHost()}${URL_MANAGEMENT}/requests/statistics?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(STATISTICS.MUTATIONS.GET_BUSINESS_STATISTICS, resp.data)
  },
  async [STATISTICS.ACTIONS.CLEAR_BUSINESS_STATISTICS] ({ commit }) {
    commit(STATISTICS.MUTATIONS.CLEAR_BUSINESS_STATISTICS)
  }
}

const mutations = {
  [STATISTICS.MUTATIONS.GET_IDENTITY_STATISTICS] (state, model) {
    state[STATISTICS.STATE.IDENTITY_STATISTICS] = model
  },
  [STATISTICS.MUTATIONS.CLEAR_IDENTITY_STATISTICS] (state) {
    state[STATISTICS.STATE.IDENTITY_STATISTICS] = null
  },
  [STATISTICS.MUTATIONS.GET_BUSINESS_STATISTICS] (state, model) {
    state[STATISTICS.STATE.BUSINESS_STATISTICS] = model
  },
  [STATISTICS.MUTATIONS.CLEAR_BUSINESS_STATISTICS] (state) {
    state[STATISTICS.STATE.BUSINESS_STATISTICS] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
